/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */
import { BaseBookmarkAdapter } from '../BaseBookmarkAdapter/BaseBookmarkAdapter';

// eslint-disable-next-line import/prefer-default-export
export class DatastoreBookmarkAdapter extends BaseBookmarkAdapter {
    constructor(dto) {
        super();
        if (!dto) {
            throw new Error(
                `dto is required when instantiating a new DatastoreBookmarkAdapter object`
            );
        }

        [`datastore`].forEach((name) => {
            if (!dto[name]) {
                throw new Error(
                    `${name} property is required when instantiating a new BookmarkService object`
                );
            }
        });

        this.datastore = dto.datastore;
        this.collectionName = `bookmarks`;
    }

    /**
     * Get bookmarks.
     *
     * @param {string} documentId The bookmark document id.
     *
     * @returns {Promise<object>} The result of the datastore query to get bookmarks.
     */
    getAll(documentId) {
        return this.datastore
            .collection(this.collectionName)
            .doc(documentId)
            .get()
            .then((response) => {
                try {
                    return JSON.parse(response);
                } catch (err) {
                    return response || '';
                }
            });
    }

    /**
     * Update an bookmark with new values.
     *
     * @param {object} bookmarks The bookmark object.
     * @param {string} documentId The bookmark document id.
     *
     * @returns {Promise<object>}The result of the datastore update query.
     */
    setAll(bookmarks, documentId) {
        return this.datastore
            .collection(this.collectionName)
            .doc(documentId)
            .update(JSON.stringify(bookmarks));
    }
}
